export const popElementFromParams = (name: string, search: string | undefined) => {
  const arr = search && search.replace('?', '').split('&')
  if (!arr) return
  let pc
  for (let i = 0; i < arr.length; i++) {
    if (!arr[i].includes(name)) continue
    pc = arr[i].split('=').pop()
    break
  }
  return pc
}

export const concatElementsFromParams = (name: string, search: string | undefined) => {
  const arr = search && search.toLowerCase().replace('?', '').split('&')
  if (!arr) return
  let delim = ''
  let paramValues = ''
  for (let i = 0; i < arr.length; i++) {
    if (!arr[i].includes(name)) continue
    paramValues += delim + arr[i]
    delim = '&'
  }
  return paramValues
}

export const existsInParamsCheck = (name: string, search: string | undefined) => {
  return (
    search && typeof search === 'string' && search.length > 0 && search.toLowerCase().includes(name)
  )
}